module.exports = __webpack_public_path__ + "img/doe.834ed65c.png";